import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './@app/redux/storeConfig/store';
import { ToastContainer, toast } from 'react-toastify';
const LazyApp = lazy(() => import('./@app'));
toast.configure({
  autoClose: 8000,
  draggable: false,
})
ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={"loading ... "}>
      <ToastContainer />
      <LazyApp />
    </Suspense>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();